export enum ProgressBarColor {
  blue = "blue",
  orange = "orange",
  red = "red",
  green = "green",
}
